<template>
  <div>
    <v-card outlined>
      <v-card-text class="text-left" style="max-height : 430px; overflow-y: auto">
        <table style="width:100%;margin-bottom: 1em">
          <tr>
            <th style="text-align:center" colspan="2">ผลประโยชน์และความคุ้มครอง</th>
          </tr>
          <tr>
            <td>ผลประโยชน์ภาวะโคม่า หรือ กรณีเจ็บป่วยระยะสุดท้าย จากโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19)</td>
            <td>: คุ้มครองไม่เกินจำนวนเงินทุนประกันภัยเริ่มต้นของกรมธรรม์ฉบับที่มีจำนวนเงินเอาประกันภัยสูงสุด *</td>
          </tr>
          <tr>
            <td>ผลประโยชน์การชดเชยรายได้ระหว่างการเข้ารักษาตัวใน รพ.จากโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19)</td>
            <td valign="top">: คุ้มครองสูงสุดวันละ 1,000 บาท ไม่เกิน 15 วัน *</td>
          </tr>
          <tr>
            <td colspan="2">*รายละเอียดเป็นไปตามข้อกำหนดและเงื่อนไขด้านล่าง</td>
          </tr>
        </table>
        <ul>
          <li>
            <p>บริษัทฯ ขอสงวนสิทธิ์ให้ความคุ้มครองเพิ่มเติมโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19) แก่ลูกค้าที่ลงทะเบียนผ่าน LINE Generali Thailand วันที่ 21 เมษายนถึงวันที่ 20 มิถุนายน 2563 เท่านั้น</p>
          </li>
          <li>
            <p>
              ลูกค้าผู้มีสิทธิ์ลงทะเบียน ได้แก่ ลูกค้าที่ถือกรมธรรม์แบบประกันรายบุคคล รวมถึงแบบคุ้มครองสินเชื่อของบริษัทเจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) และบริษัท เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) สูงสุดต่อท่านไม่เกิน 1 สิทธิ์
              <u>โดยกรมธรรม์ที่ถืออยู่ ยังคงสถานะมีผลบังคับใช้ภายในวันที่ 10 เมษายน 2563</u>
            </p>
          </li>
          <li>
            <p>
              ระยะเวลาคุ้มครอง เริ่มตั้งแต่วันที่ 1 พฤษภาคม เวลา 00.01 น. หรือวันและเวลาที่ลงทะเบียนเสร็จสิ้นสมบูรณ์ โดยสิ้นสุดความคุ้มครองในวันที่ 30 มิถุนายน 2563 เวลา 24.00 น.
              <u>หรือ</u> วันที่กรมธรรม์สิ้นสุด กรณีกรมธรรม์ของลูกค้าสิ้นผลบังคับก่อนวันที่ 30 มิถุนายน 2563
            </p>
          </li>
          <li>
            <p>สิทธิ์ความคุ้มครองนี้ มอบให้เฉพาะลูกค้ากรมธรรม์รายบุคคลและแบบคุ้มครองสินเชื่อประเภทกลุ่มเท่านั้น</p>
          </li>
          <li>
            <p>ลูกค้าที่ได้รับสิทธิ์ขยายเวลาคุ้มครองไวรัส โคโรนา 2019 (COVID-19) ฟรี ทันที โดยไม่ต้องลงทะเบียน คือลูกค้าที่มีสถานะกรมธรรม์ มีผลบังคับใช้ระหว่างวันที่ 11 เมษายน 2563 – 30 มิถุนายน 2563</p>
          </li>
          <li>
            <p>กรณีเจ็บป่วยภาวะโคม่า หรือ กรณีเจ็บป่วยระยะสุดท้าย จากโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19) คุ้มครองไม่เกินจำนวนเงินทุนประกันภัยเริ่มต้นของกรมธรรม์ฉบับที่มีจำนวนเงินเอาประกันภัยจำนวนสูงสุด ณ วันที่เรียกร้องสิทธิ์ ทั้งนี้ไม่เกิน 100,000 บาท</p>
          </li>
          <li>
            <p>กรณีการชดเชยรายได้จากการเข้ารักษาตัวในโรงพยาบาลแบบผู้ป่วยในจากโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19) คุ้มครองสูงสุดวันละ 1,000 บาท ไม่เกิน 15 วัน (การเริ่มต้นใช้สิทธิ์เรียกร้องตามกรมธรรม์ต้องเกิดขึ้นภายในระยะเวลาเอาประกันภัย)</p>
          </li>
          <li>
            <p>กรมธรรม์ของลูกค้าจะต้องมีสถานะมีผลบังคับอยู่ ณ วันเรียกร้องสิทธิ์ความคุ้มครองโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19)</p>
          </li>
        </ul>
      </v-card-text>
    </v-card>
    <!-- ข้อกำหนดและเงื่อนไข
    บริษัทฯ ขอสงวนสิทธิ์ให้ความคุ้มครองเพิ่มเติมครอบคลุมโรคติดเชื้อไวรัสโคโรนา 2019 (Covid-19) แก่ลูกค้าที่ลงทะเบียนผ่าน LINE Generali Thailand เสร็จสิ้นสมบูรณ์ ภายในระยะเวลาวันที่ 16 เมษายนถึงวันที่ 20 มิถุนายน 2563 เท่านั้น
    ลูกค้าลงทะเบียน ได้แก่ลูกค้าที่ถือกรมธรรม์แบบประกันรายบุคคล รวมถึงแบบคุ้มครองสินเชื่อของบริษัทเจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) และบริษัท เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) สูงสุดต่อท่านไม่เกิน 1 สิทธิ์ ที่มีกรมธรรม์อยู่ในสถานะมีผลบังคับใช้ภายในวันที่ 10 เมษายน 2563 โดยรับสิทธิ์ความคุ้มครอง เริ่มตั้งแต่วันที่ 1 พฤษภาคม หรือวันที่ลงทะเบียนเสร็จสิ้นสมบูรณ์ ถึงวันที่ 30 มิถุนายน 2563 ยกเว้นลูกค้าแบบประกันกลุ่ม ประเภทสวัสดิการพนักงานและประกันภัยการเดินทาง และลูกค้าประกันภัยศรีสวัสดิ์
    กรณีเจ็บป่วยภาวะโคม่า หรือ กรณีเจ็บป่วยระยะสุดท้าย จากโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19) คุ้มครองไม่เกินจำนวนเงินทุนประกันภัยเริ่มต้นของกรมธรรม์ฉบับที่มีจำนวนเงินเอาประกันภัยจำนวนสูงสุด ณ วันที่เรียกร้องสิทธิ์ ทั้งนี้ไม่เกิน 100,000 บาท
    กรณีการชดเชยรายได้จากการเข้ารักษาตัวในโรงพยาบาลแบบผู้ป่วยในจากโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19) คุ้มครองสูงสุดวันละ 1,000 บาท ไม่เกิน 15 วัน (การเริ่มต้นใช้สิทธิ์เรียกร้องตามกรมธรรม์ต้องเกิดขึ้นภายในระยะเวลาเอาประกันภัย)
    กรมธรรม์ของลูกค้าจะต้องมีสถานะมีผลบังคับอยู่ ณ วันเรียกร้องสิทธิ์ความคุ้มครองโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19)-->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
table,
th,
td {
  border: 1px solid rgb(184, 184, 184);
  border-collapse: collapse;
  font-size: 12px;
  padding: 5px;
}
</style>